// todo: currently not used
export const BuilderActionMenu = () => {
  return null
  // const { listChecked, topBarColor } = useAppBuilderContext()
  // const {
  //   actionMenuState: { activeMenu, activeMenuAnchorRef, menuOpened, setMenuOpened },
  // } = useBuilderActionContextV2() || {}
  // const [scheme] = useBuilderColorSchemeV2()
  // const { simulateAction } = useBuilderActionContextV2() || {}
  // // Memoized handleClick function for each menu item
  // const createHandleClick = useCallback(
  //   (menuItem: any, rowIndex?: number, tableId?: string, rowId?: string) => {
  //     return () => {
  //       const checkedListTable = listChecked?.extraActionProps.table as TableAdapter | undefined
  //       const isMultiple = !!listChecked && !!checkedListTable && !!listChecked.items.length
  //       const multipleOptTableId = checkedListTable?.id
  //       if (menuItem.actions && menuItem.actions?.length > 0) {
  //         simulateAction({
  //           actions: menuItem.actions,
  //           rowIndex,
  //           tableId,
  //           rowId,
  //           multipleOptions: isMultiple
  //             ? {
  //                 tableId: multipleOptTableId as string,
  //                 rowIds: listChecked.items,
  //               }
  //             : undefined,
  //         })
  //       }
  //       // Close the menu after action
  //       setMenuOpened(false)
  //     }
  //   },
  //   [listChecked, simulateAction, setMenuOpened]
  // )
  // // Convert menu items to DropdownMenuContentItem format
  // const dropdownItems = useMemo(() => {
  //   if (!activeMenu?.items) return []
  //   return activeMenu.items.map((menuItem) => {
  //     // Extract title directly from the menuItem since we can't call hooks here
  //     const title = typeof menuItem.title === 'string' ? menuItem.title : 'Menu Item'
  //     // Get icon based on the pattern from CompActionToMenuItem
  //     let iconElement = undefined
  //     if (menuItem.icon?.flag === VariableSelectFeatureFlag.Icon && menuItem.icon?.value) {
  //       iconElement = <MaterialIcon icon={menuItem.icon.value} size={16} />
  //     }
  //     return {
  //       label: title,
  //       icon: iconElement,
  //       onClick: createHandleClick(menuItem),
  //     }
  //   })
  // }, [activeMenu?.items, createHandleClick])
  // if (!activeMenu || !activeMenu.items || activeMenu.items.length === 0) return null
  // const mode = scheme.current
  // const currentTopBarColor = topBarColor[mode]
  // return (
  //   <DropDownMenu
  //     backgroundColor={currentTopBarColor}
  //     items={dropdownItems}
  //     open={menuOpened}
  //     onOpenChange={(open) => setMenuOpened(open)}
  //     anchorElement={activeMenuAnchorRef.current}
  //   />
  // )
}
